"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var DeviceService_1 = require('../../../services/DeviceService');
var PhoneInput = (function () {
    function PhoneInput(el, deviceService) {
        this.el = el;
        this.deviceService = deviceService;
    }
    // TODO: select phone only for phones
    // ngOnInit() {
    // 	this.deviceService.getDevice()
    // 	.then( device => {
    // 		console.log(device.json());
    // 	})
    // }
    PhoneInput.prototype.ngAfterViewInit = function () {
        this.el.nativeElement.children[0].select();
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], PhoneInput.prototype, "phone", void 0);
    PhoneInput = __decorate([
        core_1.Component({
            selector: 'phone-input',
            template: "\n\t\t<input id=\"phone\" class=\"value\" [value]='phone' type='text' readonly/>\n\t",
            styles: [require('./phone-input.css')]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _a) || Object, (typeof (_b = typeof DeviceService_1.DeviceService !== 'undefined' && DeviceService_1.DeviceService) === 'function' && _b) || Object])
    ], PhoneInput);
    return PhoneInput;
    var _a, _b;
}());
exports.PhoneInput = PhoneInput;



/*****************
 ** WEBPACK FOOTER
 ** ./app/steps/phonecall/phone-input/phone-input.ts
 ** module id = 943
 ** module chunks = 1
 **/